import React from 'react';
import bindDeviceActions from './redux/bindDeviceActions';
import { getDeviceLabel } from '../../common/ambient';
import { useDevice } from './redux/hooks';
// import PropTypes from 'prop-types';

const DeviceName = bindDeviceActions(({ device, actions, deviceId, stale = 5 }) => {
  const theDevice = useDevice(device, actions, deviceId, stale);
  if (!theDevice) return null;
  return <span className='device-name'>{getDeviceLabel(theDevice)}</span>;
});
export default DeviceName;

DeviceName.propTypes = {};
DeviceName.defaultProps = {};

DeviceName.displayName = 'DeviceName'
